import React from 'react';
import {CSSTransition, Transition, TransitionGroup} from "react-transition-group";
import sheep2 from '../../images/alps/sheep.png'

import uuid from 'uuid'



function Schaf(props) {

    const renderSheep = () => {
        if (props.show) {
            return  (

                <div>
                    <img src={sheep2} style={sheep}/>
                </div>


            )
        }
    }

    return(
        <TransitionGroup>
            <CSSTransition
                key={uuid()}
                timeout={600}
                classNames='fade'>
                {renderSheep}
            </CSSTransition>
        </TransitionGroup>

    )

}


export default Schaf



const sheep = {
    position: 'fixed',
    zIndex: -1,
    maxHeight: '90%',
    maxWidth:'100%',
    left:'0',
    right:'0',
    top:'0',
    bottom:'0',
    margin:'auto'
}

